import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { UserDetailModel, UserPaginatedModel, UserPaginatedRequestModel, UserCreateRequestModel } from '../models/user.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class UserApi {
  private readonly http = inject(HttpClient);
  private readonly USERS = '/Users';

  getUsersAll(request: UserPaginatedRequestModel): Observable<DataEndpoint<UserPaginatedModel>> {
    const url = this.USERS;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<UserPaginatedModel>>(url, { params })
      .pipe(map((data: DataEndpoint<UserPaginatedModel>) => {
        return {...data}
      }));
  }

  createUser(request: UserCreateRequestModel): Observable<DataEndpoint<any>> {
    const url = this.USERS;

    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }

  updateUser(userId: string, request: UserCreateRequestModel): Observable<DataEndpoint<any>> {
    const url = `${this.USERS}/${userId}`;

    return this.http.put<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }

  getUserById(userId: string): Observable<DataEndpoint<UserDetailModel>> {
    const url = `${this.USERS}/${userId}`;

    return this.http.get<DataEndpoint<UserDetailModel>>(url)
      .pipe(map((data: DataEndpoint<UserDetailModel>) => {
        return {...data}
      }));
  }

  updateUserStatus(id: string): Observable<DataEndpoint<any>> {
    const url = `${this.USERS}/${id}/status`;

    return this.http.patch<DataEndpoint<any>>(url, {})
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }

  getUserProfile(): Observable<DataEndpoint<UserDetailModel>> {
    const url = `${this.USERS}/profile`;

    return this.http.get<DataEndpoint<UserDetailModel>>(url)
      .pipe(map((data: DataEndpoint<UserDetailModel>) => {
        return {...data}
      }));
  }
}
